export const DEFAULT_STEP = 1;
export const THUMB_DIAMETER = 16;
export const DEFAULT_MIN_VALUE = 0;
export const DEFAULT_MAX_VALUE = 100;
export const DEFAULT_MIN_LABEL = String(DEFAULT_MIN_VALUE);
export const DEFAULT_MAX_LABEL = String(DEFAULT_MAX_VALUE);

export const DEFAULT_MIN = {
  value: DEFAULT_MIN_VALUE,
  label: DEFAULT_MIN_LABEL,
};

export const DEFAULT_MAX = {
  value: DEFAULT_MAX_VALUE,
  label: DEFAULT_MAX_LABEL,
};
